export default {"src":"/_next/static/media/USDC.74c6aa75.svg","height":2000,"width":2000,"blurWidth":0,"blurHeight":0};